import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChart8: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconChart8"><Path fillRule="evenodd" clipRule="evenodd" d="M21 21H3V3H21V21ZM7 17H9V12H7V17ZM11 17H13V7H11V17ZM15 10V17H17V10H15Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChart8;
